module.exports = __webpack_public_path__ + "img/108-armenia.caf85301.svg";